import React, { useState, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Container, Label, Button, FormGroup, Form, Input } from 'reactstrap';

import { Baseline } from './shared/components';
import ResponseDescription from './ResponseDescription';
import WithLoader from './WithLoader';
import DysregulatedStudentForm from './DysregulatedStudentForm';
import authorizedFetch, { authorizedPost } from './api-authorization/AuthorizedFetch';
import { safeParseResponse } from '../utils';


const CheckIn = () => {
    const history = useHistory();
    const { id } = useParams();

    const [value, setValue] = useState(5);
    const [checkInsData, setCheckInsData] = useState(undefined);
    const [preferredActivityId, setPreferredActivityId] = useState(undefined);
    const [ isDysregulatedFormOpen, setIsDysregulatedFormOpen ] = useState(false);

    const fetchData = async done => {
        const response = await authorizedFetch(`api/check-ins/${id}`);
        const { className: nameOfClass, ...rest } = await safeParseResponse(response);
        // todo - what is a good example of a response from this API?
        // eric: response sample
        /*
            {
                checkInId: "string representation of a Guid",
                className: "Mrs. Evans - 4th Grade",
                activities: [
                    {
                        name: "Dancing",
                        preferredActivityId: "string representation of a Guid"
                    }
                ]
            }
        */
        // what is className coming from?
        // eric: when a check-in is created, it is created for a class. The name of the class is where className comes from
        // todo - make try/catch helper function to safely parse
        // todo - make error boundary
        setCheckInsData({ nameOfClass, ...rest});
        done();
    };

    const submitResponse = async () => {
        if (value <= 2.5) {
            setIsDysregulatedFormOpen(true);
        } else {
            await authorizedPost(`api/check-ins/${id}/response`, {
                value,
                preferredActivityId
            });
            history.push(`/check-ins/${id}/summary`);
        }
    };

    const preferredActivityChanged = e => {
        if (e?.target?.checked) {
            const newId = e.target.value;
            setPreferredActivityId(newId);
        }
    };

    const valueChanged = e => setValue(e);

    const toggleDysregulatedForm = useCallback(() => {
        setIsDysregulatedFormOpen(s => !s);
    }, [setIsDysregulatedFormOpen]);

    const onDysregulationSubmitted = async dysregulationActivity => {
        const data = { value, preferredActivityId, dysregulationActivity };
        await authorizedPost(`api/check-ins/${id}/response`, data);
        history.push(`/check-ins/${id}/summary`);
    };

    // todo - what to name this?
    // eric: I believe you've already handled this in fetchData and no longer need to do this
    // const { className: checkInsClassName = '' } = checkInsData;

    return (
        <Container>
            <h3>Check In</h3>
            <h5>{checkInsData?.nameOfClass}</h5>
            <WithLoader action={fetchData}>
                <Form>
                    <FormGroup row>
                        <Baseline value={value} onChange={valueChanged} />
                    </FormGroup>
                    <FormGroup>
                        <h6 style={{textAlign:'center', height: '2rem'}}>
                            <ResponseDescription response={value} />
                        </h6>
                    </FormGroup>
                    <FormGroup>
                        <h5>Preferred Activity</h5>
                        {checkInsData?.activities?.map(({ name: preferredActivityName, preferredActivityId }) => 
                            <FormGroup check>
                                <Input 
                                    type="radio" 
                                    name="preferredActivity" 
                                    value={preferredActivityId} 
                                    onChange={preferredActivityChanged} 
                                />
                                <Label check>{preferredActivityName}</Label>
                            </FormGroup>
                        )}
                    </FormGroup>
                    <FormGroup row style={{ justifyContent:'center' }}>
                        <Button 
                            color="primary" 
                            style={{ width: '20%' }} 
                            onClick={submitResponse}
                        >
                            Submit
                        </Button>
                    </FormGroup>
                </Form>
            </WithLoader>
            <DysregulatedStudentForm 
                isOpen={isDysregulatedFormOpen} 
                toggle={toggleDysregulatedForm} 
                onSubmit={onDysregulationSubmitted} 
            />
        </Container>
    );
}

export default CheckIn;